<div class="other-apps">
  <h4 class="pt-4 pb-4 text-center text-md-left">Other Apps</h4>
  <div class="row ">
    @if (specification) {
      <div class="col-lg-6 col-md-4 col-6">
        <div class="card text-center" routerLink="/container-specification">
          <img src="../assets/images/icons/container-specification.png" class="card-img-top img-fluid app-img" alt="Emission Calculator">
          <div class="card-body">
            <h5 class="card-title">Container <br>Specification</h5>
            <a routerLink="/container-specification" class="btn btn-primary btn-details">Details</a>
          </div>
        </div>
      </div>
    }
    @if (emission) {
      <div class="col-lg-6 col-md-4 col-6">
        <div class="card text-center" routerLink="/emission-calculator">
          <img src="../assets/images/icons/emission-calculator.png" class="card-img-top img-fluid app-img" alt="Emission Calculator">
          <div class="card-body">
            <h5 class="card-title">Emission <br>Calculator</h5>
            <a routerLink="/emission-calculator" class="btn btn-primary btn-details">Details</a>
          </div>
        </div>
      </div>
    }

    @if (freight) {
      <div class="col-lg-6 col-md-4 col-6">
        <div class="card text-center" routerLink="/freight-volume-calculator">
          <img src="../assets/images/icons/freight-volume-calculator.png" class="card-img-top img-fluid app-img" alt="Freight Volume Calculator">
          <div class="card-body">
            <h5 class="card-title">Freight Volume <br>Calculator</h5>
            <a routerLink="/freight-volume-calculator" class="btn btn-primary btn-details">Details</a>
          </div>
        </div>
      </div>
    }

    @if (ContainerVessel) {
      <div class="col-lg-6 col-md-4 col-6">
        <div class="card text-center" routerLink="/container-vessel-tracker">
          <img src="../assets/images/icons/container-vessel-tracker.png" class="card-img-top img-fluid app-img" alt="Container Vessel Tracker">
          <div class="card-body">
            <h5 class="card-title">Container <br> Vessel Tracker</h5>
            <a routerLink="/container-vessel-tracker" class="btn btn-primary btn-details">Details</a>
          </div>
        </div>
      </div>
    }

    @if (inco) {
      <div class="col-lg-6 col-md-4 col-6">
        <div class="card text-center" routerLink="/inco-terms">
          <img src="../assets/images/icons/inco-terms.png" class="card-img-top img-fluid app-img" alt="Inco Terms">
          <div class="card-body">
            <h5 class="card-title">INCO <br>Terms</h5>
            <a routerLink="/inco-terms" class="btn btn-primary btn-details">Details</a>
          </div>
        </div>
      </div>
    }

    @if (shipping) {
      <div class="col-lg-6 col-md-4 col-6">
        <div class="card text-center" routerLink="/shipping-glossary">
          <img src="../assets/images/icons/shipping-glossary.png" class="card-img-top img-fluid app-img" alt="Shipping Glossary">
          <div class="card-body">
            <h5 class="card-title">Shipping <br>Glossary</h5>
            <a routerLink="/shipping-glossary" class="btn btn-primary btn-details">Details</a>
          </div>
        </div>
      </div>
    }

  </div>
</div>